import React from 'react'
import { EllipseContainerPosition } from './styles'
import { TimelineTooltipEnclosed, EllipseButton } from '~/components/shared'
import { IHealthProcedures } from '~/interfaces'
import { HealthProcedureVariantProps } from '~/constants'
import { formatHealthProceduresTooltipDescriptionWithDate, preventTooltipOfBigDescriptionsIn } from '~/utils'

export interface TimelineEllipseButtonProps {
  healthProcedures: IHealthProcedures[]
  position: number
  quantity: number
  onClick: (healthProcedures: IHealthProcedures[]) => void
}

export const TimelineEllipseButton = ({
  healthProcedures,
  position,
  quantity,
  onClick
}: TimelineEllipseButtonProps): JSX.Element => {
  const ellipseVariant = HealthProcedureVariantProps[healthProcedures[0].type]
  const descriptions: string[] = formatHealthProceduresTooltipDescriptionWithDate(healthProcedures)
  const tooltipDescriptionMultiline = preventTooltipOfBigDescriptionsIn(descriptions)

  const verifyIfHasAlert = (healthProcedures: IHealthProcedures[]): boolean => {
    return healthProcedures.some(healthProcedure => healthProcedure.isAltered)
  }

  return (
    <EllipseContainerPosition position={position} onClick={() => onClick(healthProcedures)}>
      <TimelineTooltipEnclosed description={tooltipDescriptionMultiline}>
        <EllipseButton
          alert={verifyIfHasAlert(healthProcedures)}
          iconName={ellipseVariant.iconName}
          color={ellipseVariant.color}
          quantity={quantity}
        />
      </TimelineTooltipEnclosed>
    </EllipseContainerPosition>
  )
}
